import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

export interface TrajectoryPoint {
  period: string;
  date: string;
  rank: number;
  clickShare?: number | null;
  conversionShare?: number | null;
  isNewEntry?: boolean;
  isExit?: boolean;
}

export interface AsinTrajectorySeries {
  asin: string;
  brand?: string;
  points: TrajectoryPoint[];
}

export interface ASINTrajectoryProps {
  data: AsinTrajectorySeries[];
}

export const ASINTrajectory: React.FC<ASINTrajectoryProps> = ({ data }) => {
  // Build a combined x-axis domain and series mapping
  const xLabels = Array.from(
    new Set(
      data
        .flatMap((s) => s.points)
        .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())
        .map((p) => p.period)
    )
  );

  const colorPalette = [
    '#1890ff',
    '#eb2f96',
    '#faad14',
    '#52c41a',
    '#722ed1',
    '#13c2c2',
    '#f5222d',
    '#2f54eb',
    '#a0d911',
    '#fa8c16',
  ];

  // Prepare chart data by aligning points to common x-axis
  const chartData = xLabels.map((label) => {
    const row: any = { period: label };
    for (const series of data) {
      const p = series.points.find((pt) => pt.period === label);
      row[series.asin] = p ? p.rank : null;
    }
    return row;
  });

  return (
    <ResponsiveContainer width="100%" height={360}>
      <LineChart data={chartData} margin={{ top: 10, right: 20, left: 10, bottom: 10 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="period" />
        <YAxis reversed domain={[1, 'dataMax']} allowDecimals={false} label={{ value: '排名(越小越靠前)', angle: -90, position: 'insideLeft' }} />
        <Tooltip />
        <Legend />
        {data.map((series, idx) => (
          <Line
            key={series.asin}
            type="monotone"
            dataKey={series.asin}
            stroke={colorPalette[idx % colorPalette.length]}
            dot={{ r: 2 }}
            activeDot={{ r: 4 }}
            connectNulls
          />
        ))}
      </LineChart>
    </ResponsiveContainer>
  );
};

export default ASINTrajectory;



